module.exports = __webpack_public_path__ + "img/skill-check.13954069.svg";